import { ErrorSharp } from "@mui/icons-material";
import React from "react";
import "./InputErrorMessage.css";

interface InputErrorMessageProps {
    passed: boolean | undefined;
    message: string | undefined;
}

const InputErrorMessage: React.FC<InputErrorMessageProps> = ({ passed, message }) => {
    return !passed ? (
        <span className="input-error-container">
            <ErrorSharp className="input-error-container__icon"></ErrorSharp>
            <span>{message}</span>
        </span>
    ) : null;
};

export default InputErrorMessage;
